import { useMemo, useState, useEffect } from 'react';
import { generateDailyPuzzle, getTodayDateString } from '../utils/puzzleGenerator';
import { fetchPuzzleStatus } from '../utils/api';

export function useDailyPuzzle() {
  const dateString = getTodayDateString();
  const puzzle = useMemo(() => generateDailyPuzzle(dateString), [dateString]);
  const [definitions, setDefinitions] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function loadDefinitions() {
      const maxAttempts = 6;
      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        try {
          const result = await fetchPuzzleStatus(dateString);
          if (cancelled) return;
          const defs = result?.definitions || {};
          const ready = result?.ready === true;
          setDefinitions(defs);
          if (ready || attempt === maxAttempts - 1) {
            setIsLoading(false);
            return;
          }
        } catch {
          if (cancelled) return;
        }
        // Wait before retrying (3s between attempts)
        await new Promise(r => setTimeout(r, 3000));
        if (cancelled) return;
      }
      setIsLoading(false);
    }

    loadDefinitions();
    return () => { cancelled = true; };
  }, [dateString]);

  return useMemo(() => ({ ...puzzle, definitions, isLoading }), [puzzle, definitions, isLoading]);
}
